/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

import type {
  AddConversationLabelReq,
  AppApiPlatformConversationsPutAvailableCustomColumnsReq,
  ConversationDetailsReq,
  ConversationLabel,
  CustomConversationColumn,
  DeleteAvailableCustomColumnsReq,
  DeleteConversationLabelReq,
  GetAvailableConversationLabelsReq,
  GetAvailableConversationLabelsRes,
  GetAvailableCustomColumnsReq,
  GetAvailableCustomColumnsRes,
  GetConversationDetailResp,
  GetConversationInteractionsReq,
  GetConversationInteractionsResp,
  GetConversationsReq,
  GetInternalConversationIdReq,
  GetInternalConversationIdResp,
  HTTPValidationError,
  PaginatedConversationsQuery,
  ResponseMessage,
} from '../model';

import { customFetch } from '../../fetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getGetConversationsUrl = () => {
  return `/api/v1/conversations/get-conversations`;
};

/**
 * @summary Get Conversations
 */
export const getConversations = async (
  getConversationsReq: GetConversationsReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedConversationsQuery> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<PaginatedConversationsQuery>(getGetConversationsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getConversationsReq),
  });
};

export const getGetConversationsMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getConversations>>,
    TError,
    GetConversationsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getConversations>>,
  TError,
  GetConversationsMutationVariables,
  TContext
> => {
  const mutationKey = ['getConversations'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getConversations>>,
    GetConversationsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getConversations(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetConversationsMutationResult = NonNullable<Awaited<ReturnType<typeof getConversations>>>;
export type GetConversationsMutationBody = GetConversationsReq;
export type GetConversationsMutationError = HTTPValidationError;
export type GetConversationsMutationVariables = { data: GetConversationsReq };

/**
 * @summary Get Conversations
 */
export const useGetConversations = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getConversations>>,
    TError,
    GetConversationsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getConversations>>,
  TError,
  GetConversationsMutationVariables,
  TContext
> => {
  return useMutation(getGetConversationsMutationOptions(options));
};
export const getGetConversationDetailsUrl = () => {
  return `/api/v1/conversations/details`;
};

/**
 * @summary Get Conversation Details
 */
export const getConversationDetails = async (
  conversationDetailsReq: ConversationDetailsReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetConversationDetailResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GetConversationDetailResp>(getGetConversationDetailsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(conversationDetailsReq),
  });
};

export const getGetConversationDetailsMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getConversationDetails>>,
    TError,
    GetConversationDetailsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getConversationDetails>>,
  TError,
  GetConversationDetailsMutationVariables,
  TContext
> => {
  const mutationKey = ['getConversationDetails'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getConversationDetails>>,
    GetConversationDetailsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getConversationDetails(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetConversationDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof getConversationDetails>>>;
export type GetConversationDetailsMutationBody = ConversationDetailsReq;
export type GetConversationDetailsMutationError = HTTPValidationError;
export type GetConversationDetailsMutationVariables = { data: ConversationDetailsReq };

/**
 * @summary Get Conversation Details
 */
export const useGetConversationDetails = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getConversationDetails>>,
    TError,
    GetConversationDetailsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getConversationDetails>>,
  TError,
  GetConversationDetailsMutationVariables,
  TContext
> => {
  return useMutation(getGetConversationDetailsMutationOptions(options));
};
export const getGetConversationInteractionsUrl = () => {
  return `/api/v1/conversations/interactions`;
};

/**
 * @summary Get Conversation Interactions
 */
export const getConversationInteractions = async (
  getConversationInteractionsReq: GetConversationInteractionsReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetConversationInteractionsResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GetConversationInteractionsResp>(getGetConversationInteractionsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getConversationInteractionsReq),
  });
};

export const getGetConversationInteractionsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getConversationInteractions>>,
    TError,
    GetConversationInteractionsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getConversationInteractions>>,
  TError,
  GetConversationInteractionsMutationVariables,
  TContext
> => {
  const mutationKey = ['getConversationInteractions'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getConversationInteractions>>,
    GetConversationInteractionsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getConversationInteractions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetConversationInteractionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getConversationInteractions>>
>;
export type GetConversationInteractionsMutationBody = GetConversationInteractionsReq;
export type GetConversationInteractionsMutationError = HTTPValidationError;
export type GetConversationInteractionsMutationVariables = { data: GetConversationInteractionsReq };

/**
 * @summary Get Conversation Interactions
 */
export const useGetConversationInteractions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getConversationInteractions>>,
    TError,
    GetConversationInteractionsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getConversationInteractions>>,
  TError,
  GetConversationInteractionsMutationVariables,
  TContext
> => {
  return useMutation(getGetConversationInteractionsMutationOptions(options));
};
export const getGetInternalConversationIdUrl = () => {
  return `/api/v1/conversations/internal-id`;
};

/**
 * @summary Get Internal Conversation Id
 */
export const getInternalConversationId = async (
  getInternalConversationIdReq: GetInternalConversationIdReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetInternalConversationIdResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GetInternalConversationIdResp>(getGetInternalConversationIdUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getInternalConversationIdReq),
  });
};

export const getGetInternalConversationIdMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getInternalConversationId>>,
    TError,
    GetInternalConversationIdMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getInternalConversationId>>,
  TError,
  GetInternalConversationIdMutationVariables,
  TContext
> => {
  const mutationKey = ['getInternalConversationId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getInternalConversationId>>,
    GetInternalConversationIdMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getInternalConversationId(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetInternalConversationIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof getInternalConversationId>>
>;
export type GetInternalConversationIdMutationBody = GetInternalConversationIdReq;
export type GetInternalConversationIdMutationError = HTTPValidationError;
export type GetInternalConversationIdMutationVariables = { data: GetInternalConversationIdReq };

/**
 * @summary Get Internal Conversation Id
 */
export const useGetInternalConversationId = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getInternalConversationId>>,
    TError,
    GetInternalConversationIdMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getInternalConversationId>>,
  TError,
  GetInternalConversationIdMutationVariables,
  TContext
> => {
  return useMutation(getGetInternalConversationIdMutationOptions(options));
};
export const getGetConversationAvailableCustomColumnsUrl = () => {
  return `/api/v1/conversations/get-available-custom-columns`;
};

/**
 * @summary Get Available Custom Columns
 */
export const getConversationAvailableCustomColumns = async (
  getAvailableCustomColumnsReq: GetAvailableCustomColumnsReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetAvailableCustomColumnsRes> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GetAvailableCustomColumnsRes>(getGetConversationAvailableCustomColumnsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getAvailableCustomColumnsReq),
  });
};

export const getGetConversationAvailableCustomColumnsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getConversationAvailableCustomColumns>>,
    TError,
    GetConversationAvailableCustomColumnsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getConversationAvailableCustomColumns>>,
  TError,
  GetConversationAvailableCustomColumnsMutationVariables,
  TContext
> => {
  const mutationKey = ['getConversationAvailableCustomColumns'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getConversationAvailableCustomColumns>>,
    GetConversationAvailableCustomColumnsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getConversationAvailableCustomColumns(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetConversationAvailableCustomColumnsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getConversationAvailableCustomColumns>>
>;
export type GetConversationAvailableCustomColumnsMutationBody = GetAvailableCustomColumnsReq;
export type GetConversationAvailableCustomColumnsMutationError = HTTPValidationError;
export type GetConversationAvailableCustomColumnsMutationVariables = { data: GetAvailableCustomColumnsReq };

/**
 * @summary Get Available Custom Columns
 */
export const useGetConversationAvailableCustomColumns = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getConversationAvailableCustomColumns>>,
    TError,
    GetConversationAvailableCustomColumnsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getConversationAvailableCustomColumns>>,
  TError,
  GetConversationAvailableCustomColumnsMutationVariables,
  TContext
> => {
  return useMutation(getGetConversationAvailableCustomColumnsMutationOptions(options));
};
export const getPutConversationAvailableCustomColumnsUrl = () => {
  return `/api/v1/conversations/available-custom-columns`;
};

/**
 * @summary Put Available Custom Columns
 */
export const putConversationAvailableCustomColumns = async (
  appApiPlatformConversationsPutAvailableCustomColumnsReq: AppApiPlatformConversationsPutAvailableCustomColumnsReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomConversationColumn[]> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CustomConversationColumn[]>(getPutConversationAvailableCustomColumnsUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(appApiPlatformConversationsPutAvailableCustomColumnsReq),
  });
};

export const getPutConversationAvailableCustomColumnsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putConversationAvailableCustomColumns>>,
    TError,
    PutConversationAvailableCustomColumnsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putConversationAvailableCustomColumns>>,
  TError,
  PutConversationAvailableCustomColumnsMutationVariables,
  TContext
> => {
  const mutationKey = ['putConversationAvailableCustomColumns'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putConversationAvailableCustomColumns>>,
    PutConversationAvailableCustomColumnsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return putConversationAvailableCustomColumns(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutConversationAvailableCustomColumnsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putConversationAvailableCustomColumns>>
>;
export type PutConversationAvailableCustomColumnsMutationBody = AppApiPlatformConversationsPutAvailableCustomColumnsReq;
export type PutConversationAvailableCustomColumnsMutationError = HTTPValidationError;
export type PutConversationAvailableCustomColumnsMutationVariables = {
  data: AppApiPlatformConversationsPutAvailableCustomColumnsReq;
};

/**
 * @summary Put Available Custom Columns
 */
export const usePutConversationAvailableCustomColumns = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putConversationAvailableCustomColumns>>,
    TError,
    PutConversationAvailableCustomColumnsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putConversationAvailableCustomColumns>>,
  TError,
  PutConversationAvailableCustomColumnsMutationVariables,
  TContext
> => {
  return useMutation(getPutConversationAvailableCustomColumnsMutationOptions(options));
};
export const getDeleteConversationCustomColumnsUrl = () => {
  return `/api/v1/conversations/available-custom-columns`;
};

/**
 * @summary Delete Custom Columns
 */
export const deleteConversationCustomColumns = async (
  deleteAvailableCustomColumnsReq: DeleteAvailableCustomColumnsReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<ResponseMessage> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResponseMessage>(getDeleteConversationCustomColumnsUrl(), {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteAvailableCustomColumnsReq),
  });
};

export const getDeleteConversationCustomColumnsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteConversationCustomColumns>>,
    TError,
    DeleteConversationCustomColumnsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteConversationCustomColumns>>,
  TError,
  DeleteConversationCustomColumnsMutationVariables,
  TContext
> => {
  const mutationKey = ['deleteConversationCustomColumns'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteConversationCustomColumns>>,
    DeleteConversationCustomColumnsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return deleteConversationCustomColumns(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteConversationCustomColumnsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteConversationCustomColumns>>
>;
export type DeleteConversationCustomColumnsMutationBody = DeleteAvailableCustomColumnsReq;
export type DeleteConversationCustomColumnsMutationError = HTTPValidationError;
export type DeleteConversationCustomColumnsMutationVariables = { data: DeleteAvailableCustomColumnsReq };

/**
 * @summary Delete Custom Columns
 */
export const useDeleteConversationCustomColumns = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteConversationCustomColumns>>,
    TError,
    DeleteConversationCustomColumnsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteConversationCustomColumns>>,
  TError,
  DeleteConversationCustomColumnsMutationVariables,
  TContext
> => {
  return useMutation(getDeleteConversationCustomColumnsMutationOptions(options));
};
export const getAddConversationLabelUrl = () => {
  return `/api/v1/conversations/labels`;
};

/**
 * Attach a label to a conversation (idempotent).
 * @summary Add Conversation Label
 */
export const addConversationLabel = async (
  addConversationLabelReq: AddConversationLabelReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<ConversationLabel> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ConversationLabel>(getAddConversationLabelUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addConversationLabelReq),
  });
};

export const getAddConversationLabelMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addConversationLabel>>,
    TError,
    AddConversationLabelMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addConversationLabel>>,
  TError,
  AddConversationLabelMutationVariables,
  TContext
> => {
  const mutationKey = ['addConversationLabel'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addConversationLabel>>,
    AddConversationLabelMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return addConversationLabel(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddConversationLabelMutationResult = NonNullable<Awaited<ReturnType<typeof addConversationLabel>>>;
export type AddConversationLabelMutationBody = AddConversationLabelReq;
export type AddConversationLabelMutationError = HTTPValidationError;
export type AddConversationLabelMutationVariables = { data: AddConversationLabelReq };

/**
 * @summary Add Conversation Label
 */
export const useAddConversationLabel = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addConversationLabel>>,
    TError,
    AddConversationLabelMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addConversationLabel>>,
  TError,
  AddConversationLabelMutationVariables,
  TContext
> => {
  return useMutation(getAddConversationLabelMutationOptions(options));
};
export const getDeleteConversationLabelUrl = () => {
  return `/api/v1/conversations/labels`;
};

/**
 * Remove a label from a conversation.
 * @summary Delete Conversation Label
 */
export const deleteConversationLabel = async (
  deleteConversationLabelReq: DeleteConversationLabelReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<ResponseMessage> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResponseMessage>(getDeleteConversationLabelUrl(), {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteConversationLabelReq),
  });
};

export const getDeleteConversationLabelMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteConversationLabel>>,
    TError,
    DeleteConversationLabelMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteConversationLabel>>,
  TError,
  DeleteConversationLabelMutationVariables,
  TContext
> => {
  const mutationKey = ['deleteConversationLabel'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteConversationLabel>>,
    DeleteConversationLabelMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return deleteConversationLabel(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteConversationLabelMutationResult = NonNullable<Awaited<ReturnType<typeof deleteConversationLabel>>>;
export type DeleteConversationLabelMutationBody = DeleteConversationLabelReq;
export type DeleteConversationLabelMutationError = HTTPValidationError;
export type DeleteConversationLabelMutationVariables = { data: DeleteConversationLabelReq };

/**
 * @summary Delete Conversation Label
 */
export const useDeleteConversationLabel = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteConversationLabel>>,
    TError,
    DeleteConversationLabelMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteConversationLabel>>,
  TError,
  DeleteConversationLabelMutationVariables,
  TContext
> => {
  return useMutation(getDeleteConversationLabelMutationOptions(options));
};
export const getGetAvailableConversationLabelsUrl = () => {
  return `/api/v1/conversations/get-available-labels`;
};

/**
 * Return all distinct conversation labels currently used in this project.
 * @summary Get Available Conversation Labels
 */
export const getAvailableConversationLabels = async (
  getAvailableConversationLabelsReq: GetAvailableConversationLabelsReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetAvailableConversationLabelsRes> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GetAvailableConversationLabelsRes>(getGetAvailableConversationLabelsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getAvailableConversationLabelsReq),
  });
};

export const getGetAvailableConversationLabelsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAvailableConversationLabels>>,
    TError,
    GetAvailableConversationLabelsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAvailableConversationLabels>>,
  TError,
  GetAvailableConversationLabelsMutationVariables,
  TContext
> => {
  const mutationKey = ['getAvailableConversationLabels'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAvailableConversationLabels>>,
    GetAvailableConversationLabelsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getAvailableConversationLabels(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAvailableConversationLabelsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAvailableConversationLabels>>
>;
export type GetAvailableConversationLabelsMutationBody = GetAvailableConversationLabelsReq;
export type GetAvailableConversationLabelsMutationError = HTTPValidationError;
export type GetAvailableConversationLabelsMutationVariables = { data: GetAvailableConversationLabelsReq };

/**
 * @summary Get Available Conversation Labels
 */
export const useGetAvailableConversationLabels = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAvailableConversationLabels>>,
    TError,
    GetAvailableConversationLabelsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getAvailableConversationLabels>>,
  TError,
  GetAvailableConversationLabelsMutationVariables,
  TContext
> => {
  return useMutation(getGetAvailableConversationLabelsMutationOptions(options));
};
